<template>
  <div class="crud_form_wrapper">
    <!-- Start:: Title -->
    <div class="form_title_wrapper">
      <h4>{{ $t("PLACEHOLDERS.view_client_data") }}</h4>
    </div>
    <div class="col-12 text-end">
      <v-btn @click="$router.go(-1)" style="color: #446e80">
        <i class="fas fa-backward"></i>
      </v-btn>
    </div>
    <!-- End:: Title -->

    <!-- Start:: Single Step Form Content -->
    <div class="single_step_form_content_wrapper">
      <form>
        <div class="row">
          <!-- Start:: Avatar Display -->
          <div class="col-12" v-if="data.avatar">
            <div class="input_wrapper d-flex flex-column align-items-center">
              <label>{{ $t("PLACEHOLDERS.client_logo") }}</label>
              <div class="image_preview_wrapper">
                <img
                  :src="data.avatar"
                  :alt="data.name"
                  style="max-width: 150px; border-radius: 8px"
                />
              </div>
            </div>
          </div>
          <!-- End:: Avatar Display -->

          <!-- Start:: Name Input -->
          <base-input
            col="6"
            type="text"
            :placeholder="$t('PLACEHOLDERS.name')"
            v-model.trim="data.name"
            disabled
          />
          <!-- End:: Name Input -->

          <!-- Start:: Email Input -->
          <base-input
            col="6"
            type="email"
            :placeholder="$t('PLACEHOLDERS.email')"
            v-model.trim="data.email"
            disabled
          />
          <!-- End:: Email Input -->

          <!-- Start:: Mobile Input -->
          <base-input
            col="6"
            type="text"
            :placeholder="$t('PLACEHOLDERS.mobile')"
            v-model.trim="data.mobile"
            disabled
          />
          <!-- End:: Mobile Input -->

          <!-- Start:: Created At Input -->
          <base-input
            col="6"
            type="text"
            :placeholder="$t('PLACEHOLDERS.created_at')"
            v-model.trim="data.created_at"
            disabled
          />
          <!-- End:: Created At Input -->

          <!-- Start:: Activation Switch Input -->
          <div class="input_wrapper switch_wrapper my-5 col-6">
            <v-switch
              color="green"
              :label="
                data.is_active
                  ? $t('PLACEHOLDERS.active')
                  : $t('PLACEHOLDERS.notActive')
              "
              v-model="data.is_active"
              hide-details
              disabled
            ></v-switch>
          </div>
          <!-- End:: Activation Switch Input -->
        </div>
      </form>
    </div>
    <!-- END:: Single Step Form Content -->
  </div>
</template>

<script>
export default {
  name: "ShowClient",

  data() {
    return {
      // Start:: Data Collection
      data: {
        name: null,
        email: null,
        mobile: null,
        avatar: null,
        created_at: null,
        is_active: true,
      },
      // End:: Data Collection
    };
  },

  methods: {
    // Start:: Get Data
    async getData() {
      try {
        let res = await this.$axios({
          method: "GET",
          url: `clients/${this.$route.params.id}`,
        });
        this.data.name = res.data.data?.data.name;
        this.data.email = res.data.data?.data.email;
        this.data.mobile = res.data.data?.data.mobile;
        this.data.avatar = res.data.data?.data.image;
        this.data.created_at = res.data.data?.data.created_at;
        this.data.is_active = res.data.data?.data.is_active;
      } catch (error) {
        console.log(error?.response?.data?.message);
      }
    },
    // End:: Get Data
  },

  created() {
    this.getData();
  },
};
</script>
